"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _FormMessage = _interopRequireDefault(require("../Forms/_FormMessage"));

var _FormValidationOverlay = _interopRequireDefault(require("../Forms/_FormValidationOverlay"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _keycode = _interopRequireDefault(require("keycode"));

var _List = _interopRequireDefault(require("../List/List"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _button = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/button.css") : void 0);

var _list = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/list.css") : void 0);

var _select = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/select.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread(_objectSpread({}, _list.default), _button.default), _select.default));
/** A **Select** component lets the user select one of the different options.
It is more flexible than the normal Select. Use with the **List** component. */

var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  ariaHidden: true,
  glyph: "slim-arrow-down"
});

var Select = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context;

  var className = _ref.className,
      controlClassName = _ref.controlClassName,
      compact = _ref.compact,
      cssNamespace = _ref.cssNamespace,
      disabled = _ref.disabled,
      emptyAriaLabel = _ref.emptyAriaLabel,
      id = _ref.id,
      includeEmptyOption = _ref.includeEmptyOption,
      listClassName = _ref.listClassName,
      listItemClassName = _ref.listItemClassName,
      listItemTextClassName = _ref.listItemTextClassName,
      options = _ref.options,
      onBlur = _ref.onBlur,
      onClick = _ref.onClick,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder,
      popoverProps = _ref.popoverProps,
      readOnly = _ref.readOnly,
      selectedKey = _ref.selectedKey,
      textContentClassName = _ref.textContentClassName,
      triggerClassName = _ref.triggerClassName,
      validationOverlayProps = _ref.validationOverlayProps,
      validationState = _ref.validationState,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "controlClassName", "compact", "cssNamespace", "disabled", "emptyAriaLabel", "id", "includeEmptyOption", "listClassName", "listItemClassName", "listItemTextClassName", "options", "onBlur", "onClick", "onSelect", "placeholder", "popoverProps", "readOnly", "selectedKey", "textContentClassName", "triggerClassName", "validationOverlayProps", "validationState"]);
  var internalDivRef = (0, _react.useRef)(null);
  var divRef = ref || internalDivRef;
  var popoverRef = (0, _react.useRef)(null);
  var ulRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(selectedKey),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedOptionKey = _useState2[0],
      setSelectedOptionKey = _useState2[1];

  (0, _react.useEffect)(function () {
    setSelectedOptionKey(selectedKey);
  }, [selectedKey, options]);

  var handleClick = function handleClick(e) {
    if (!disabled && !readOnly) {
      onClick(e);
    }
  };

  var handleBlur = function handleBlur(e) {
    var _popoverRef$current, _popoverRef$current$s;

    if (!(popoverRef !== null && popoverRef !== void 0 && (_popoverRef$current = popoverRef.current) !== null && _popoverRef$current !== void 0 && (_popoverRef$current$s = _popoverRef$current.state) !== null && _popoverRef$current$s !== void 0 && _popoverRef$current$s.isExpanded) && onBlur) {
      onBlur(e);
    }
  };

  var handleSelect = function handleSelect(e, option) {
    var popover = popoverRef && popoverRef.current;
    popover && popover.handleEscapeKey();
    setSelectedOptionKey(option.key);
    onSelect(e, option);
  };

  var handleOptionKeyDown = function handleOptionKeyDown(e, option) {
    switch ((0, _keycode.default)(e)) {
      case 'esc':
      case 'tab':
        e.stopPropagation();
        var popover = popoverRef && popoverRef.current;
        popover && popover.handleEscapeKey();
        break;

      case 'enter':
      case 'space':
        e.preventDefault();
        handleSelect(e, option);
        break;

      default:
    }
  };

  var selectClasses = classnames("".concat(cssNamespace, "-select"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-select--compact"), compact), className);
  var selectControlClasses = classnames("".concat(cssNamespace, "-select__control"), (0, _defineProperty2.default)({
    'is-disabled': disabled,
    'is-readonly': readOnly
  }, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state), controlClassName);
  var triggerClassNames = classnames("".concat(cssNamespace, "-button"), "".concat(cssNamespace, "-button--transparent"), "".concat(cssNamespace, "-select__button"), triggerClassName);
  var textContentClassNames = classnames("".concat(cssNamespace, "-select__text-content"), textContentClassName);
  var displayOptions = includeEmptyOption ? (0, _concat.default)(_context = [{
    text: '',
    key: 'emptyOption',
    ariaLabel: emptyAriaLabel
  }]).call(_context, (0, _toConsumableArray2.default)(options)) : options;
  var selected = (0, _find.default)(displayOptions).call(displayOptions, function (option) {
    return typeof selectedOptionKey !== 'undefined' && option.key === selectedOptionKey;
  });
  var selectedIndex = (0, _findIndex.default)(displayOptions).call(displayOptions, function (option) {
    return typeof selectedOptionKey !== 'undefined' && option.key === selectedOptionKey;
  });
  var firstFocusIndex = selectedIndex > -1 ? selectedIndex : 0;
  var textContent = selected ? selected.text : placeholder;
  var selectAriaLabel = includeEmptyOption && !textContent ? emptyAriaLabel : null;

  var selectControl = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: selectClasses,
    id: id,
    ref: divRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: selectControlClasses
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-label": selectAriaLabel,
    className: textContentClassNames
  }, textContent), !readOnly && /*#__PURE__*/_react.default.createElement("span", {
    className: triggerClassNames
  }, _ref2)));

  var tabIndex = disabled ? -1 : 0;

  var wrappedSelectControl = /*#__PURE__*/_react.default.createElement(_FormValidationOverlay.default, (0, _extends2.default)({}, validationOverlayProps, {
    "aria-disabled": disabled,
    "aria-readonly": readOnly,
    control: selectControl,
    onClick: handleClick,
    role: 'combobox',
    tabIndex: tabIndex,
    validationState: validationState
  }));

  var listBoxClassName = classnames("".concat(cssNamespace, "-list--dropdown"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-list--has-message"), validationState === null || validationState === void 0 ? void 0 : validationState.state), listClassName);
  return /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
    placement: "bottom-start",
    widthSizingType: "minTarget"
  }, popoverProps, {
    body: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, validationState && /*#__PURE__*/_react.default.createElement(_FormMessage.default, (0, _extends2.default)({
      forPopoverList: true
    }, validationOverlayProps === null || validationOverlayProps === void 0 ? void 0 : validationOverlayProps.formMessageProps, {
      type: validationState.state
    }), validationState.text), /*#__PURE__*/_react.default.createElement(_List.default, {
      className: listBoxClassName,
      compact: compact,
      ref: ulRef,
      role: "listbox",
      tabIndex: "-1"
    }, (0, _map.default)(displayOptions).call(displayOptions, function (option) {
      return /*#__PURE__*/_react.default.createElement(_List.default.Item, {
        "aria-label": option.ariaLabel,
        "aria-selected": (selected === null || selected === void 0 ? void 0 : selected.key) === option.key,
        className: listItemClassName,
        key: option.key,
        onClick: function onClick(e) {
          return handleSelect(e, option);
        },
        onKeyDown: function onKeyDown(e) {
          return handleOptionKeyDown(e, option);
        },
        role: "option",
        selected: (selected === null || selected === void 0 ? void 0 : selected.key) === option.key,
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement(_List.default.Text, {
        className: listItemTextClassName
      }, option.text));
    }))),
    control: wrappedSelectControl,
    disableKeyPressHandler: disabled || readOnly,
    disableTriggerOnClick: disabled || readOnly,
    firstFocusIndex: firstFocusIndex,
    noArrow: true,
    onBlur: handleBlur,
    onClickOutside: handleBlur,
    ref: popoverRef,
    type: "listbox",
    useArrowKeyNavigation: true
  }));
});

Select.displayName = 'Select';
process.env.NODE_ENV !== "production" ? Select.propTypes = {
  /** CSS class(es) to add to the select `<div>` element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** CSS class(es) to add to the control wrapping `<div>` element */
  controlClassName: _propTypes.default.string,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Localized screen reader label for an empty option if included, or if no placeholder is included */
  emptyAriaLabel: _propTypes.default.string,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** Set to **true** to include an empty option. If true, also provide an `emptyAriaLabel` */
  includeEmptyOption: _propTypes.default.bool,

  /** CSS class(es) to add to the option list element */
  listClassName: _propTypes.default.string,

  /** CSS class(es) to add to the list item elements */
  listItemClassName: _propTypes.default.string,

  /** CSS class(es) to add to the list item child `<span>` elements */
  listItemTextClassName: _propTypes.default.string,

  /** An array of objects with a key and text to render the selectable options */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  })),

  /** Localized placeholder text of the input */
  placeholder: _propTypes.default.string,

  /** Additional props to be spread to the Popover component */
  popoverProps: _propTypes.default.object,

  /** Set to **true** to enable readonly mode */
  readOnly: _propTypes.default.bool,

  /** The key corresponding to the selected option */
  selectedKey: _propTypes.default.string,

  /** CSS class(es) to add to the text content `<span>` element */
  textContentClassName: _propTypes.default.string,

  /** CSS class(es) to add to the trigger `<span>` element */
  triggerClassName: _propTypes.default.string,

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /**
   * Callback function; triggered when the select field loses focus and the popover is closed.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
   * */
  onBlur: _propTypes.default.func,

  /**
   * Callback function; triggered when user clicks on the select field.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
   * */
  onClick: _propTypes.default.func,

  /**
   * Callback function; triggered when user selects on an option from the dropdown option list by clicking
   * or by pressing `enter` or `space`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {Object} selectedOption - select object from the options array.
   * @returns {void}
   * */
  onSelect: _propTypes.default.func
} : void 0;
Select.defaultProps = {
  options: [],
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onSelect: function onSelect() {}
};

var _default = (0, _withStyles.default)(Select);

exports.default = _default;